import { ThunkDispatch } from 'redux-thunk'
import { MainState } from '../reducers'
import * as constants from './constants'

export type MainThunkDispatchType = ThunkDispatch<MainState, null, SidebarActions>

export interface ToggleSidebar {
  type: constants.TOGGLE_SIDEBAR
  visible: boolean
}

export interface SetActiveMenuItem {
  type: constants.SET_ACTIVE_MENU_ITEM
  item: string
  path: string
}

export interface SetActiveSubMenuItem {
  type: constants.SET_ACTIVE_SUB_MENU_ITEM
  item: string
  path: string
}

export interface SetActiveDropdownMenuItem {
  type: constants.SET_ACTIVE_DROPDOWN_MENU_ITEM
  item: string
  path: string
}

export interface SetOpenConfirmModal {
  type: constants.OPEN_CONFIRM_MODAL
  open: boolean
}

export interface SetFromOpen {
  type: constants.SET_FORM_OPEN
  open: boolean
}

export interface SetFormDirty {
  type: constants.SET_FORM_DIRTY
  dirty: boolean
}


export interface OpenConfirmModal {
  type: constants.OPEN_CONFIRM_MODAL
  open: boolean
}

export const toggleSidebar = (visible: boolean): ToggleSidebar => {
  return {
    type: constants.TOGGLE_SIDEBAR,
    visible
  }
}

export const setActiveMenuItem = (item: string, path: string): SetActiveMenuItem => {
  return {
    type: constants.SET_ACTIVE_MENU_ITEM,
    item,
    path
  }
}

export const setActiveSubMenuItem = (item: string, path: string): SetActiveSubMenuItem => {
  return {
    type: constants.SET_ACTIVE_SUB_MENU_ITEM,
    item,
    path
  }
}

export const setActiveDropdownMenuItem = (item: string, path: string): SetActiveDropdownMenuItem => {
  return {
    type: constants.SET_ACTIVE_DROPDOWN_MENU_ITEM,
    item,
    path
  }
}

export const setOpenConfirmModal = (open: boolean): SetOpenConfirmModal => {
  return {
    type: constants.OPEN_CONFIRM_MODAL,
    open
  }
}

export const setFormOpen = (open: boolean): SetFromOpen => {
  return {
    type: constants.SET_FORM_OPEN,
    open
  }
}

export const setFormDrity = (dirty: boolean): SetFormDirty => {
  return {
    type: constants.SET_FORM_DIRTY,
    dirty
  }
}

export type SidebarActions
  = ToggleSidebar
  | SetActiveMenuItem
  | SetActiveSubMenuItem
  | SetActiveDropdownMenuItem
  | OpenConfirmModal
  | SetFromOpen
  | SetFormDirty
